import { RouteConfig } from 'vue-router';
import ActivityLogsComponent from './activitylogs.component.vue';

export const ActivityLogsRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'activitylogs',
  component: ActivityLogsComponent,
  // redirect: 'activitylogs/loginlogout',
  // children: [
  //   {
  //     name: 'activitylogs.loginlogout',
  //     path: 'loginlogout',
  //     component: UserLoginLogoutActivityLogs,
  //   },
  // ],
};

export function getDefaultParams() {
  return {};
}
